var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingio-spinner-rolling-2by998twmg8",class:_vm.classType},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ldio-yzaezf3dcmj"},[_c('div')])
}]

export { render, staticRenderFns }